import printHistoryComponent from "./print_history.component";


let printHistoryModule = angular.module('printHistory', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/contract.edit');

        $stateProvider
            .state('printHistory', {
                url: '/print-contract-rules-update-history',
                component: 'printHistory',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_contract.edit'
                },
            })
    })

    .component('printHistory', printHistoryComponent)

    .name;

export default printHistoryModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/print/index.js